/**
 * useMotion — returns the canonical motion tokens (durations/easings/springs).
 *
 * Motion is theme-invariant, so this simply returns the MOTION constant. Easings
 * are cubic-bézier control points; apply them at the call site, e.g.
 *   Easing.bezier(...useMotion().easing.standard)
 */
import { MOTION } from '@/constants/shared/theme/motion';
import type { Motion } from '@/constants/shared/theme';

export function useMotion(): Motion {
  return MOTION;
}
